<script>
  export default {
    name: 'app-page-header',
    data () {
      return {
        breadcrumbItems: [],
        currentRoute: {meta: {breadcrumb: {name: ''}}},
        parentRoute: {meta: {breadcrumb: {name: ''}}}
      }
    },
    mounted () {
      this.atualizarBreadcrumb()
    },
    computed: {
      parentRouteName: function () {
        return this.parentRoute.meta.breadcrumb.name || ''
      },
      currentRouteName: function () {
        return this.currentRoute.meta.breadcrumb.name || ''
      },
      tituloPagina: function () {
        return (this.parentRouteName ? (this.parentRouteName + ' / ') : '') + this.currentRouteName
      }
    },
    watch: {
      '$route': function () {
        this.atualizarBreadcrumb()
      }
    },
    methods: {
      atualizarBreadcrumb () {
        this.currentRoute = this.$route
        let parent = null
        if (this.currentRoute.matched && this.currentRoute.matched.length > 0) {
          parent = this.currentRoute.matched[0]
          if (parent && parent.name !== this.currentRoute.name) {
            this.parentRoute = parent
          }
        }
        this.breadcrumbItems.splice(0)
        this.breadcrumbItems.push({name: 'Início', to: 'dashboard'})
        if (this.parentRoute.meta && this.parentRoute.meta.breadcrumb && this.parentRoute.meta.breadcrumb.name !== '') {
          this.breadcrumbItems.push(this.parentRoute.meta.breadcrumb)
        }
        if (this.currentRoute.meta && this.currentRoute.meta.breadcrumb && this.currentRoute.meta.breadcrumb.name !== '') {
          this.breadcrumbItems.push(this.currentRoute.meta.breadcrumb)
        }
      }
    }
  }
</script>

<template>
    <div class="page-header-content">
        <ul class="v-breadcrumbs">
        <span v-for="(item, index) in breadcrumbItems">
            <li>
                <router-link :to="{name: item.to, params: item.params}" v-if="item.to">{{item.name}}</router-link>
                <span v-if="!item.to" class="breadcrumbs-simple">{{item.name}}</span>
            </li>
            <li class="v-breadcrumbs__divider" v-if="index < (breadcrumbItems.length - 1)">/</li>
        </span>
        </ul>
        <h2 class="page-title">{{tituloPagina}}</h2>
    </div>
</template>

<style lang="scss">
    .v-breadcrumbs {
        margin: 0;
        padding: 0 0 10px;
        list-style: none;
        span li {
            color: #878787;
            a {
                text-decoration: none;
                color: #4C7C48;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// PageHeader.vue?60de1328